// The customer's cart, kept on this device (localStorage) and shared by the
// home page, the shop and the cart page. Prices aren't stored: the server
// works them out from its catalog when the order is placed.
//   line: { key, itemId, sizeId?, weightKg, quantity, custom?, note? }
import { useEffect, useState } from "react";

const KEY = "tod_cart";
const EVENT = "tod-cart-changed";

export function getCart() {
  try {
    const lines = JSON.parse(window.localStorage.getItem(KEY) || "[]");
    return Array.isArray(lines) ? lines : [];
  } catch (e) {
    return [];
  }
}

function saveCart(lines) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(lines));
  } catch (e) {
    // storage blocked: the cart lasts until the page reloads
  }
  window.dispatchEvent(new Event(EVENT));
}

let nextKey = Date.now();

// Past this many cakes it's a bulk order, arranged on WhatsApp: asking for more
// doesn't add them, and components/BulkBanner shows why.
export const MAX_CAKES = 20;
export const BULK_EVENT = "tod-cart-too-many";
export const notifyTooMany = () => window.dispatchEvent(new Event(BULK_EVENT));

// Adds a cake; the same cake and weight (not custom) adds to its quantity.
// Answers false when that would be too many.
export function addToCart({
  itemId,
  sizeId,
  weightKg = 1,
  quantity = 1,
  custom,
  note,
}) {
  const lines = getCart();
  if (cartCount(lines) + quantity > MAX_CAKES) {
    notifyTooMany();
    return false;
  }
  const same =
    !custom &&
    lines.find(
      (l) =>
        l.itemId === itemId &&
        !l.custom &&
        l.sizeId === sizeId &&
        l.weightKg === weightKg,
    );
  if (same) same.quantity += quantity;
  else
    lines.push({
      key: String(nextKey++),
      itemId,
      sizeId,
      weightKg,
      quantity,
      custom,
      note,
    });
  saveCart(lines);
  return true;
}

export function updateCartLine(key, changes) {
  saveCart(getCart().map((l) => (l.key === key ? { ...l, ...changes } : l)));
}
export function removeCartLine(key) {
  saveCart(getCart().filter((l) => l.key !== key));
}
export function clearCart() {
  saveCart([]);
}
export const cartCount = (lines = getCart()) =>
  lines.reduce((n, l) => n + (Number(l.quantity) || 0), 0);

// The cart, kept up to date when any page changes it (or another tab).
export function useCart() {
  const [lines, setLines] = useState(getCart);
  useEffect(() => {
    const refresh = () => setLines(getCart());
    window.addEventListener(EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);
  return lines;
}
